import moment from "moment-timezone";
import { extendMoment } from "moment-range";

moment.tz.setDefault("Europe/Moscow");

export default extendMoment(moment);
